// ...existing code...
import React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import Env from '../../hooks/Env';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Info } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
// import { libelleEts } from '../../pages/RecrutementPer/config';

const COLORS = {
    brandBordeaux: '#99381F',
    brandBlue: '#00A7E1'
};
const niveau = ["Licence 2", "Licence 3"];

function InfomationEtudiant({ infos }) {
    const [show, setShow] = useState(true);
    const handleClose = () => {setShow(false)};
    const navigate = useNavigate();
    const [errorMsg, setErrorMsg] = useState('');

    const handleContinue = async () => {
        setErrorMsg('');

        // si la sélection de filière est visible, s'assurer qu'une filière est choisie
        if (showFiliereSelect && !selectedFiliere) {
            setErrorMsg('Veuillez sélectionner une spécialité avant de continuer.');
            return;
        }

        // poster la spécialité sélectionnée pour mise à jour
            try {
                if (selectedFiliere && infos?.email) {
                    const formData = new FormData();
                    // ajouter les mêmes champs que l'ancien envoi
                    formData.append('email', infos.email);
                    if (infos?.date_naissance) formData.append('date_naissance', infos.date_naissance);
                    if (infos?.prenom) formData.append('prenom', infos.prenom);
                    if (infos?.nom) formData.append('nom', infos.nom);
                    if (infos?.codePermanent) formData.append('codePermanent', infos.codePermanent);
                    // champ attendu par le backend (Insomnia montre 'specialite')
                    formData.append('specialite', selectedFiliere);

                    // DEBUG: lister les paires pour vérifier le contenu avant envoi
                    for (const p of formData.entries()) {
                        // eslint-disable-next-line no-console
                        console.log('formData:', p[0], p[1]);
                    }

                    // Utiliser l'URL absolue (évite redirections locales qui causent 307)
                    const url = `${API_URL}/reinscription/update`;
                    const response = await axios.post(url, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    if (response.status !== 200) {
                        console.error('Réponse inattendue', response.status, response.data);
                        setErrorMsg('Erreur serveur: ' + (response.status || 'inconnue'));
                        return;
                    }
                    if (response.data?.detail) {
                        console.error('Erreur backend:', response.data.detail);
                        setErrorMsg(response.data.detail.toString());
                        return;
                    }
                }
                setShow(false);
                // navigate('/');
            } catch (err) {
                console.error('Erreur mise à jour spécialité', err);
                // si le backend renvoie une payload d'erreur, l'afficher
                const serverMsg = err?.response?.data?.detail || err?.response?.data || err?.message;
                setErrorMsg(serverMsg ? String(serverMsg) : 'Erreur lors de la mise à jour, veuillez réessayer.');
            }
    }

   
    const [selectedFiliere, setSelectedFiliere] = useState('');

    // Détecter le sigle de l'établissement à partir du libellé (si possible)
    const etablissementLibelle = infos?.etablissement || '';

    // Récupérer dynamiquement les filières depuis l'API /specialite
    const { API_URL } = Env();
    const [apiFilieres, setApiFilieres] = useState([]);

    useEffect(() => {
        if (!infos) {
            setApiFilieres([]);
            return;
        }

        const source = axios.CancelToken.source();

        axios.get(`${API_URL}/specialite/`, { cancelToken: source.token })
            .then(res => {
                const data = res.data || [];
                // Filtrer par établissement (libelle), niveau (nom) et formation (nom)
                const filtered = data.filter(s => {
                    const etsLib = s.etablissement?.libelle || '';
                    const niveauNom = s.niveau?.nom || '';
                    const formationNom = s.formation?.nom || '';
                    // comparer en ignorant la casse
                    const etsMatch = etsLib.toLowerCase() === etablissementLibelle.toLowerCase() || etablissementLibelle.toLowerCase().includes(etsLib.toLowerCase()) || etsLib.toLowerCase().includes(etablissementLibelle.toLowerCase());
                    const niveauMatch = niveauNom.toLowerCase() === (infos?.niveau || '').toLowerCase();
                    // comparer la formation du candidat (infos.formation_reinscription) avec la formation renvoyée par l'API
                    const candidatFormation = (infos?.formation_reinscription || '').toString();
                    const formationMatch = candidatFormation ? (formationNom.toLowerCase() === candidatFormation.toLowerCase() || candidatFormation.toLowerCase().includes(formationNom.toLowerCase()) || formationNom.toLowerCase().includes(candidatFormation.toLowerCase())) : true;
                    return etsMatch && niveauMatch && formationMatch;
                }).map(s => s.nom);

                // valeurs uniques
                const unique = Array.from(new Set(filtered));
                setApiFilieres(unique);

                // pré-remplir si possible
                const existing = infos?.formation_reinscription;
                if (existing && unique.includes(existing)) {
                    setSelectedFiliere(existing);
                }
            })
            .catch(err => {
                if (!axios.isCancel(err)) console.error('Erreur récupération spécialités', err);
            });

        return () => source.cancel();
    }, [infos, API_URL, etablissementLibelle]);

    // utiliser uniquement les données API pour les filières
    const filieresOptions = apiFilieres;
    const showFiliereSelect = filieresOptions.length > 0;

    const initials = `${(infos?.prenom || '').charAt(0)}${(infos?.nom || '').charAt(0)}`.toUpperCase();

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            size="md"
        >
            <Modal.Header className="border-0">
                <div className="d-flex align-items-center">
                    <div
                        style={{
                            width: 48,
                            height: 48,
                            borderRadius: 48,
                            background: COLORS.brandBlue + '20', 
                            color: COLORS.brandBordeaux,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 700,
                            marginRight: 12,
                            boxShadow: '0 2px 6px rgba(0,0,0,0.08)'
                        }}
                        aria-hidden
                    >
                        {initials || <Info fontSize="small" />}
                    </div>
                    <div>
                        <h5 className="mb-0">Informations étudiant</h5>
                        <small className="text-muted">Vérifiez les informations avant de continuer</small>
                    </div>
                </div>
                <FontAwesomeIcon icon={faCheckCircle} style={{ color: COLORS.brandBlue }} className="ms-3" size="lg" />
            </Modal.Header>
            <Modal.Body>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-12 col-md-8">
                            <h4 className="mb-1 fw-bold" style={{ color: COLORS.brandBordeaux }}>
                                {infos?.prenom || '-'} {infos?.nom || '-'}
                            </h4>
                            <div className="mb-2">
                                <span className="badge me-2" style={{ background: COLORS.brandBordeaux, color: '#fff' }}>
                                    {infos?.classe || ''}
                                </span>
                                <span className="badge" style={{ background: COLORS.brandBlue, color: '#fff' }}>
                                    {infos?.identifiantClasse || ''}
                                </span>
                            </div>

                            <dl className="row mb-0">
                                <dt className="col-5 text-muted">Prénom</dt>
                                <dd className="col-7 fw-semibold">{infos?.prenom || '-'}</dd>

                                <dt className="col-5 text-muted">Nom</dt>
                                <dd className="col-7 fw-semibold">{infos?.nom || '-'}</dd>

                                <dt className="col-5 text-muted">Etablissement</dt>
                                <dd className="col-7 fw-semibold">{infos?.etablissement || '-'}</dd>

                                <dt className="col-5 text-muted">Formation</dt>
                                <dd className="col-7 fw-semibold">{infos?.formation_reinscription || '-'}</dd>

                                <dt className="col-7 text-muted">Niveau reinscription </dt>
                                <dd className="col-5 fw-semibold">{infos?.niveau || '-'}</dd>
                            </dl>

                        {showFiliereSelect && (
                            <div className="mt-3">
                                <Form.Group>
                                    <Form.Label className="fw-medium">Choisissez votre filière </Form.Label>
                                    <Form.Select value={selectedFiliere} onChange={(e) => { setSelectedFiliere(e.target.value); setErrorMsg(''); }}>
                                        <option value="">-- Sélectionner une filière --</option>
                                        {filieresOptions.map((f, idx) => (
                                            <option key={idx} value={f}>{f}</option>
                                        ))}
                                    </Form.Select>
                                        {errorMsg ? <div className="text-danger mt-2">{errorMsg}</div> : null}
                                </Form.Group>
                            </div>
                        )}
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className="border-0">
                <Button variant="success" onClick={handleContinue} style={{ background: COLORS.brandBordeaux, borderColor: COLORS.brandBordeaux }}>
                    Continuer la procédure
                </Button>

                <Link to="/" className="ms-2">
                    <Button variant="danger" onClick={handleClose} style={{ borderColor: COLORS.brandBordeaux, color: COLORS.brandBordeaux }}>
                        Annuler
                    </Button>
                </Link>
            </Modal.Footer>
        </Modal>
    );
}

export default InfomationEtudiant;